import { chipColorMap } from '../../../../ui/features/mission-details/components/utils';
import { ParticipantInfoCard } from '../../../../ui/features/ongoingShifts/components/ParticipantInfoCard';
import { ShiftInfoCard } from '../../../../ui/features/ongoingShifts/components/ShiftInfoCard';
import { ShiftParticipantTable } from '../../../../ui/features/ongoingShifts/components/ShiftParticipantTable';
import { useMissionsTranslation } from '../../../../ui/hooks';
import { getMissionStatusLabel } from '../../../../ui/utils/getMissionStatusLabel';
import { ChipLight } from '@juvare/common-web-ui/ChipLight';
import { themeColors } from '@juvare/common-web-ui/JuvareTheme';
import { Box, Button, DialogActions, DialogContent, DialogTitle, Typography } from '@mui/material';
import React from 'react';
import { useShiftAttendanceAnalytics } from '../hooks/useShiftAttendanceAnalytics';
export const ShiftParticipationDialogContent = ({ shift, missionName, missionStatus, renderFindVolunteer, onDialogClose, }) => {
    const { t } = useMissionsTranslation();
    const { shiftAttendanceAnalytics, reloadAnalytics } = useShiftAttendanceAnalytics({ shiftId: shift.id });
    return (React.createElement(React.Fragment, null,
        React.createElement(DialogTitle, null,
            React.createElement(Typography, { variant: 'h6', component: 'span' },
                missionName,
                missionStatus && (React.createElement(ChipLight, { sx: { ml: 1 }, size: 'small', label: getMissionStatusLabel(t, missionStatus, true), color: chipColorMap[missionStatus] })))),
        React.createElement(DialogContent, { sx: { padding: 2 } },
            React.createElement(Box, { sx: { display: 'flex', flexDirection: 'column', gap: 2 } },
                React.createElement(Box, { sx: { display: 'flex', gap: 2 } },
                    React.createElement(ParticipantInfoCard, { shiftAttendanceAnalytics: shiftAttendanceAnalytics }),
                    React.createElement(ShiftInfoCard, { shift: shift }),
                    React.createElement(Box, { sx: {
                            display: 'flex',
                            alignItems: 'center',
                            backgroundColor: themeColors.surface.secondary,
                            p: 2,
                            borderRadius: '4px',
                            width: '100%',
                        } }, renderFindVolunteer())),
                React.createElement(Box, { sx: { backgroundColor: themeColors.surface.secondary, p: 2, borderRadius: '4px' } },
                    React.createElement(ShiftParticipantTable, { shift: shift, onCheckInCheckOutSuccess: reloadAnalytics })))),
        React.createElement(DialogActions, null,
            React.createElement(Button, { variant: 'text', color: 'primary', onClick: () => onDialogClose() }, t('common.close')))));
};
